/** 设置页 — 支持 section 子路由（/settings/display | /ai | ...）
 *
 * 桌面端：左侧侧边栏导航
 * 移动端：顶部横向滚动 Tab
 */

import { Link, useParams } from 'react-router';
import { AIConfigPage } from './settings/AIConfigPage';
import { DisplayPage } from './settings/DisplayPage';
import { AboutPage } from './settings/AboutPage';
import { SyncPage } from './settings/SyncPage';
import { VoicePage } from './settings/VoicePage';
import { AccountPage } from './settings/AccountPage';
import { HelpPage } from './settings/HelpPage';

const sections = [
  { id: 'display', label: '显示与阅读' },
  { id: 'ai', label: 'AI 配置' },
  { id: 'account', label: '账号与会员' },
  { id: 'sync', label: '同步与备份' },
  { id: 'voice', label: '我的声音' },
  { id: 'about', label: '关于' },
  { id: 'help', label: '帮助' },
] as const;

export function SettingsPage() {
  const { section } = useParams<{ section?: string }>();
  const active = section ?? 'display';

  return (
    <div>
      {/* 移动端：顶部横向 Tab */}
      <nav className="md:hidden sticky top-0 z-10 bg-white dark:bg-warm-dark border-b border-border-warm dark:border-border-warm-dark">
        <div className="flex gap-1 overflow-x-auto px-3 py-2">
          {sections.map((s) => (
            <Link
              key={s.id}
              to={`/settings/${s.id}`}
              className={`px-3 py-1.5 rounded-md text-sm whitespace-nowrap transition-colors ${
                active === s.id
                  ? 'bg-camel/15 text-camel-dark dark:text-camel font-medium'
                  : 'text-charcoal/60 dark:text-charcoal-light/60'
              }`}
            >
              {s.label}
            </Link>
          ))}
        </div>
      </nav>

      <div className="flex">
        {/* 桌面端：左侧侧边栏 */}
        <aside className="hidden md:block w-48 shrink-0 border-r border-border-warm dark:border-border-warm-dark p-4">
          <nav className="flex flex-col gap-1">
            {sections.map((s) => (
              <Link
                key={s.id}
                to={`/settings/${s.id}`}
                className={`px-3 py-2 rounded-md text-sm transition-colors ${
                  active === s.id
                    ? 'bg-camel/15 text-camel-dark dark:text-camel font-medium'
                    : 'text-charcoal/70 dark:text-charcoal-light/70 hover:bg-warm-white dark:hover:bg-border-warm-dark'
                }`}
              >
                {s.label}
              </Link>
            ))}
          </nav>
        </aside>

        {/* 设置内容 */}
        <div className="flex-1 p-6">
          <h1 className="text-2xl font-serif text-camel-dark mb-4">
            {sections.find((s) => s.id === active)?.label ?? '设置'}
          </h1>
          {active === 'ai' ? (
            <AIConfigPage />
          ) : active === 'display' ? (
            <DisplayPage />
          ) : active === 'about' ? (
            <AboutPage />
          ) : active === 'sync' ? (
            <SyncPage />
          ) : active === 'voice' ? (
            <VoicePage />
          ) : active === 'help' ? (
            <HelpPage />
          ) : active === 'account' ? (
            <AccountPage />
          ) : (
            <p className="text-charcoal/60 dark:text-charcoal-light/60">
              设置项将在后续迭代中填充。
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
